/*eslint-disable*/
import clsx from "clsx";
import styles from "./style.module.scss";
import Title from "../title";
import { Tooltip } from "antd";
import { messages } from "@/constants";

type Props = {
  children?: React.ReactNode;
  title?: string;
  sub?: React.ReactNode;
  customTitle?: React.ReactNode;
  customClass?: string;
  rightContent?: React.ReactNode;
  iconButton?: React.ReactNode;
  customContentClass?: string;
  anotherComponent?: React.ReactNode;
  onClick?: () => void;
  style?: any;
  isBlock?: boolean;
};

export default function Section({
  children,
  title,
  sub,
  rightContent,
  customTitle,
  customClass,
  anotherComponent,
  iconButton,
  customContentClass,
  onClick,
  style,
  isBlock,
}: Props) {
  return (
    <section className={styles.section}>
      {customTitle ? (
        <div
          className={clsx(
            styles.titleArea,
            children && styles.hasChildren,
            styles.customTitle,
            customClass
          )}
        >
          {customTitle}
        </div>
      ) : !title && !sub ? null : (
        <div
          className={clsx(
            styles.titleArea,
            children && styles.hasChildren,
            customClass
          )}
        >
          <span style={style} onClick={() => onClick?.()}>
            {title ? (
              <Title className={styles.title} size="lg" color="white">
                <p> {title}</p>
                <Tooltip
                  title={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: messages.transaction(isBlock),
                      }}
                    />
                  }
                  className="text-white  rounded tooltipContent"
                >
                  <span className={styles.iconButtonStyle}>{iconButton}</span>
                </Tooltip>
              </Title>
            ) : null}
          </span>
          {sub && <div className={styles.sub}>{sub}</div>}
          {rightContent && (
            <div className={styles.anotherComp}>{rightContent}</div>
          )}
        </div>
      )}
      {anotherComponent && (
        <div className={styles.anotherComp}>{anotherComponent}</div>
      )}
      {children && (
        <div
          className={clsx(
            styles.content,
            !title && !customTitle && styles.contentAlone,
            customContentClass
          )}
        >
          {children}
        </div>
      )}
    </section>
  );
}
